module.exports = __webpack_public_path__ + "img/33.0fbcc28f.svg";